import { API_URL } from "../../config"
import { getToken } from "../../util/validation"
// import { getCurrentMonthYear } from "../util/common"


const token = JSON.parse(getToken);

export async function getRenewalData(){

    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getFollowUpComments(renewal_id){

    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'renewal_id' : renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/get_followup_comment/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getNotificationDataHttp(notify){

    try {
        console.log(notify)
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'renewal_id' : notify.renewal_id,
            'subscription_id' : notify.subscription_id,
            'domain_name' : notify.domain_name,
            'zoho_contact_id': notify.zoho_contact_id
        }

        const response = await fetch(API_URL + 'adminpanel/get_zoho_notify_customer/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function sendNotification(requestBody){

    try {
        // console.log(parseInt(subscription_id))
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'requestBody': requestBody,
        }

        const response = await fetch(API_URL + 'adminpanel/send_renewal_notification/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function insertFollowupCommentHttp(comment, renewal_id){

    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'comment': comment,
            'renewal_id' : renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/insert_followup_comment/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function updateSegmentsHttp(renewal_id, value){

    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'segments': value,
            'renewal_id' : renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/update_segments/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {
            
            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function updateZoneHttp(renewal_id, value){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'zone': value,
            'renewal_id' : renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/update_zone/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function insertComments(data, renewal_id){
    try {
        const email = localStorage.getItem('user')
        var payload = {
            'email': email,
            'formData':data,
            'renewal_id' : renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/insert_comments/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(payload),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getMonthlyRenewalData(month) {
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_monthly_renewal_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getYearlyRenewalHistory(){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_yearly_renewal_history/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getRenewalStatus(month){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_status_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getAllRenewalTeam(){

    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_team/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}


export async function GetAllRenewalManagers(){

    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_team_manager/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function createRenewalInvoice(renewal_id){

    try {
        const email = localStorage.getItem('user');

        let data = {
            'email': email,
            'renewal_id': renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/create_zoho_invoice/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export async function createRenewalProposal(renewal_id){

    try {
        const email = localStorage.getItem('user');

        let data = {
            'email': email,
            'renewal_id': renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/create_renewal_proposal/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token,
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export async function getRenewalSegmentCount(month){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_segment_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalSegmentDomains(segment){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'segment_name': segment
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_segment_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalAggrementCount(month){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_aggrement_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalAggrementDomains(aggrement){

    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'aggrement': aggrement
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_aggrement_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalFlagsCount(month){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_flags_count/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalFlagsDomains(flags){

    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'flag': flags
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_flag_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getCurrentDashboard(month) {
    try {

        const email = localStorage.getItem('user')
        let currentMonth = (new Date().getMonth() + 1).toString() 
        const currentYear = new Date().getFullYear()

        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }

        const selectMonth = month ? month : `${currentYear}-${currentMonth}`
        console.log(currentMonth)
        var data = { 
            'email': email,
            'month' : selectMonth
        }

        const response = await fetch(API_URL + 'adminpanel/get_current_month_renewal_dashboard/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getCurrentRenewalDomains(comment){
    try {

        let currentMonth = (new Date().getMonth() + 1).toString() 
        const currentYear = new Date().getFullYear()

        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'comment': comment,
            'month' : `${currentYear}-${currentMonth}%`
        }

        const response = await fetch(API_URL + 'adminpanel/get_current_month_renewal_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalDomainDetails(renewal_id){
    try {

        const email = localStorage.getItem('user')

        var data = { 
            'email': email,
            'renewal_id': renewal_id
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_domain_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getResellerList(month){
    try {

        const email = localStorage.getItem('user')

        var data = { 
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_resellers/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getRenewalResellerCustomer(month, reseller_email, tag, assigned_to){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'month': month,
            'reseller_email': reseller_email,
            'tag': tag,
            'assigned_to': assigned_to
        }

        const response = await fetch(API_URL + 'adminpanel/get_renewal_reseller_customers/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getAssignedToData(){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
        }

        const response = await fetch(API_URL + 'adminpanel/get_assigement_members_emails/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function sendResellerNotification(subscriptionIds, renewalDates, domain_name) {
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'subscriptionIds' : subscriptionIds,
            'renewalDates' : renewalDates,
            'domain_name' : domain_name
        }

        const response = await fetch(API_URL + 'adminpanel/send_reseller_notification/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function updateAssignedTo(renewal_id , assigned_to){
    try {

        const email = localStorage.getItem('user')
        var data = { 
            'email': email,
            'renewalid' : renewal_id,
            'emailid' : assigned_to
        }

        const response = await fetch(API_URL + 'adminpanel/update_assignto_member/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getMonthlyRenewalExportData(month) {
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'month': month
        }

        const response = await fetch(API_URL + 'adminpanel/get_export_monthly_renewal_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}


export async function updateBulkAssignedTo(file){
    try {


        const response = await fetch(API_URL + 'adminpanel/bulk_update_assignto_member/', {
            method: "POST",
            headers: {
                // "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: file,
        });
        
        if (response.status === 200) {

            return true
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function updateRenewalDomainData(requestBody, renewal_id){
    try {
        console.log('requesetBody',requestBody)

        await updateZoneHttp(renewal_id, requestBody.customer_zone)
        await updateSegmentsHttp(renewal_id, requestBody.customer_segment)
        await updateAssignedTo(renewal_id, requestBody.user_status)

    } catch (error) {
        return false
    }
}



export async function sendGoogleOfferHttp(requestBody){

    try {
        const email = localStorage.getItem('user')
        // NOTE: The requestBody already contains all renewal and SKU data
        var data = {
            'email': email,
            'offer_data': requestBody, // Send the entire payload including the offered_skus array
        }

        // ACTION: Define a unique API endpoint path here
        const response = await fetch(API_URL + 'adminpanel/submit_renewal_offer/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {
            return response.json()
        }
        else{
            return false
        }

    } catch (error) {
        return false
    }
}

export async function sendGoDaddyNotification(requestBody){

    try {
        // console.log(parseInt(subscription_id))
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'requestBody': requestBody,
        }

        const response = await fetch(API_URL + 'adminpanel/send_go_daddy_renewal_notification/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

// added by siddhi
export async function getKREDomainsHttp() {
    try {
        const email = localStorage.getItem('user');
        const token = JSON.parse(localStorage.getItem('token')); // Adjusted based on your getToken logic
        const data = { 'email': email };

        const response = await fetch(API_URL + 'adminpanel/get_kre_domains/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return response.json();
        }
        return false;
    } catch (error) {
        return false;
    }
}

// added by siddhi
export async function insertKAMMeetingHttp(data) {
    try {
        const email = localStorage.getItem('user');
        const token = JSON.parse(localStorage.getItem('token')); 
        const payload = {
            'email': email,
            'formData': data
        };

        const response = await fetch(API_URL + 'adminpanel/insert_kam_meeting/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(payload),
        });

        if (response.status === 200) {
            return response.json();
        }
        return false;
    } catch (error) {
        return false;
    }
}


// added by siddhi
export async function getMeetingDataHttp(domain_name) {
    try {
        const email = localStorage.getItem('user');
        const token = JSON.parse(localStorage.getItem('token')); 
        const data = { 'email': email, 'domain_name': domain_name };

        const response = await fetch(API_URL + 'adminpanel/get_kam_meeting_data/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) return response.json();
        return false;
    } catch (error) {
        return false;
    }
}

// added by siddhi
export async function sendOperationsOfferHttp(formData) {
    try {
        const email = localStorage.getItem('user');
        const payload = { 'email': email, 'formData': formData };

        const response = await fetch(API_URL + 'adminpanel/send_operations_offer/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(payload),
        });

        if (response.status === 200) return response.json();
        return false;
    } catch (error) {
        return false;
    }
}

export async function getGoogleRenewalRepsHttp() {
    try {
        const response = await fetch(API_URL + 'adminpanel/get_google_renewal_reps/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify({ email: localStorage.getItem('user') }),
        });
        if (response.status === 200) return response.json();
        return false;
    } catch (error) { return false; }
}

// added by siddhi
export async function getOperationsDomainsHttp() {
    try {
        const response = await fetch(API_URL + 'adminpanel/get_operations_domains/', { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token.login_token 
            },
            body: JSON.stringify({
                email: localStorage.getItem('user') 
            })
        });

        if (response.status === 200) {
            return response.json();
        }
        return false;
    } catch (error) {
        console.error("HTTP Error:", error);
        return false;
    }
}


//added by siddhi
export async function updateOperationsStatusHttp(payload) {
    try {
        const response = await fetch(API_URL + 'adminpanel/update_operations_status/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(payload),
        });
        if (response.status === 200) return response.json();
        return false;
    } catch (error) { return false; }
}

export async function getOperationsStatusListHttp() {
    try {
        const email = localStorage.getItem('user')
        var data = { 
            'email': email
        }
        const response = await fetch(API_URL + 'adminpanel/get_operations_status_list/', {
            method: "POST",
            headers: {    
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        if (response.status === 200) return response.json();
        return false;
    } catch (error) { return false; }
}